import React, { FC } from "react";
import { Image } from "../image";
import { A11y, EffectCoverflow, Mousewheel } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import type { ContentfulFileType } from "@/types";
import "swiper/css/mousewheel";

export const SwiperCoverflow: FC<{
  className?: string;
  size?: "regular" | "lg";
  slides: ContentfulFileType[];
}> = ({ className, slides }) => {
  return (
    <Swiper
      modules={[A11y, EffectCoverflow, Mousewheel]}
      effect="coverflow"
      slidesPerView="auto"
      grabCursor
      coverflowEffect={{
        rotate: 0,
        stretch: 100,
        slideShadows: false,
        scale: 0.95,
      }}
      breakpoints={{
        1024: {
          centeredSlides: true,
          coverflowEffect: {
            rotate: 0,
            stretch: 225,
            slideShadows: false,
            scale: 0.95,
          },
        },
      }}
      preventInteractionOnTransition
      mousewheel={{
        releaseOnEdges: true,
      }}
      onSlideChange={(e) => {
        if (window.innerWidth >= 1024) {
          const swiper = e.el;
          const rect = swiper.getBoundingClientRect();
          window.scrollTo({
            top: rect.top + window.scrollY - 100,
            behavior: "smooth",
          });
        }
      }}
      className={`swiperCoverflow ${className ? className : ""}`}
    >
      {slides.map((slide, index) => {
        return (
          <SwiperSlide key={index} className="swiperCoverflow--slide">
            {slide.file?.url && (
              <Image
                className="swiperCoverflow--slide-image"
                src={slide as any}
                alt={slide.title}
                draggable={false}
                options={{
                  sizes: {
                    exec: [
                      {
                        width: 1040,
                        height: 660,
                      },
                    ],
                  },
                }}
              />
            )}
            {slide.title && (
              <div className="swiperCoverflow--slide-text">
                {slide.description && (
                  <div
                    className="swiperCoverflow--slide-label"
                    dangerouslySetInnerHTML={{ __html: slide.title }}
                  />
                )}
                <div
                  className="swiperCoverflow--slide-title"
                  dangerouslySetInnerHTML={{
                    __html: slide.description || slide.title,
                  }}
                />
              </div>
            )}
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
};
